import {NgModule} from '@angular/core';
import {IonicPageModule} from 'ionic-angular';
import {NewRegistrationStep2Page} from './new-registration-step2';

import {IonicSelectableModule} from 'ionic-selectable';
import {BrMaskerModule} from 'brmasker-ionic-3';

@NgModule({
  declarations: [
    NewRegistrationStep2Page,
  ],
  imports: [
    IonicPageModule.forChild(NewRegistrationStep2Page),
    IonicSelectableModule,
    BrMaskerModule,
  ],
  exports: [
    NewRegistrationStep2Page
  ]
})
export class NewRegistrationStep2PageModule {
}



// WEBPACK FOOTER //
// ./src/pages/new-registration-step2/new-registration-step2.module.ts